import _classCallCheck from "/home/runner/work/mediabook/mediabook/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/mediabook/mediabook/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/mediabook/mediabook/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/mediabook/mediabook/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/mediabook/mediabook/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { QualifierValue } from "../../internal/qualifier/QualifierValue";
import { Qualifier } from "../../internal/qualifier/Qualifier";
import { DeliveryAction } from "./DeliveryAction";
/**
 * @description Controls the quality of the delivered image or video.
 * @memberOf Actions.Delivery
 * @extends {Actions.Delivery.DeliveryAction}
 * @see Visit {@link Actions.Delivery|Delivery} for an example
 */

var DeliveryQualityAction = /*#__PURE__*/function (_DeliveryAction) {
  _inherits(DeliveryQualityAction, _DeliveryAction);

  var _super = _createSuper(DeliveryQualityAction);

  /**
   * @param {Qualifiers.Quality} qualityValue a Quality value
   */
  function DeliveryQualityAction(qualityValue) {
    var _this;

    _classCallCheck(this, DeliveryQualityAction);

    _this = _super.call(this, 'q', qualityValue.toString());
    _this.qualityValue = qualityValue;
    return _this;
  }
  /**
   * Selet the Chroma sub sampling</br>
   * <b>Learn more</b>: {@link https://cloudinary.com/documentation/image_transformations#toggling_chroma_subsampling | Toggling chroma subsampling}
   * @param {420 | 444 | number} type The chroma sub sampling type
   */


  _createClass(DeliveryQualityAction, [{
    key: "chromaSubSampling",
    value: function chromaSubSampling(type) {
      var qualityWithSubSampling = new QualifierValue([this.qualityValue, type]);
      qualityWithSubSampling.setDelimiter(':'); // We either have chroma or quantization, but not both

      return this.addQualifier(new Qualifier('q', qualityWithSubSampling));
    }
    /**
     * Controls the final quality by setting a maximum quantization percentage
     * @param {number} val
     */

  }, {
    key: "quantization",
    value: function quantization(val) {
      var qualityWithQuantization = new QualifierValue([this.qualityValue, "qmax_".concat(val)]);
      qualityWithQuantization.setDelimiter(':'); // We either have chroma or quantization, but not both

      return this.addQualifier(new Qualifier('q', qualityWithQuantization));
    }
  }]);

  return DeliveryQualityAction;
}(DeliveryAction);

export { DeliveryQualityAction };